import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import useProductService from '../../../app/services/hooks/useProductService';
import { ProductDataForm, defaultProductDataForm } from '../../../app/models/Product';
import { Unit } from '../../../app/models/Unit';
import { ItemCategory } from '../../../app/models/ItemCategory';
import { Location } from '../../../app/models/Location';
import { Sector } from '../../../app/models/Sector';
import { Quality } from '../../../app/models/Quality';
import { Color } from '../../../app/models/Color';
import ProductForm from './forms/ProductForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

type SelectOpt = { id: number | string; name: string };

interface Props { productId: number; onSaved?: () => void; onCancel?: () => void; onError?: () => void; }

const NOOP = () => undefined;

const ProductClone = ({ productId, onSaved, onCancel = NOOP, onError }: Props) => {
  const { showLoading, hideLoading } = useContext(AppContext);
  const { editProduct, storeProduct, fetchingStoreProduct, fetchingEditProduct } = useProductService();

  const [product, setProduct] = useState<ProductDataForm>(defaultProductDataForm);
  const [units, setUnits] = useState<Unit[]>([]);
  const [sectors, setSectors] = useState<Sector[]>([]);
  const [categories, setCategories] = useState<ItemCategory[]>([]);
  const [locations, setLocations] = useState<Location[]>([]);
  const [qualities, setQualities] = useState<Quality[]>([]);
  const [colors, setColors] = useState<Color[]>([]);
  const [ownershipTypes, setOwnershipTypes] = useState<SelectOpt[]>([]);
  const [taxes, setTaxes] = useState<SelectOpt[]>([]);
  const [errorFields, setErrorFields] = useState<any>();

  useEffect(() => {
    loadBaseProduct();
  }, []);

  const loadBaseProduct = () => {
    showLoading?.('loading', 'Cargando producto base...');
    editProduct(productId, {
      onSuccess: (res: ServiceResponse) => {
        const base: ProductDataForm = res.data.product;
        // Clonar como nuevo: sin id, stock en 0, activo
        setProduct({
          ...base,
          id: undefined,
          stock: 0,
          is_active: true,
        });
        setUnits(res.data.units || []);
        setSectors(res.data.sectors || []);
        setCategories(res.data.categories || []);
        setLocations(res.data.locations || []);
        setQualities(res.data.qualities || []);
        setColors(res.data.colors || []);
        setOwnershipTypes(res.data.ownership_types || []);
        setTaxes(res.data.taxes || []);
        hideLoading?.();
      },
      onError: (res: ServiceResponse) => {
        hideLoading?.();
        toast.error(res.message);
        onError && onError();
      }
    });
  };

  const store = () => {
    showLoading?.('loading', 'Guardando producto...');
    storeProduct(product, {
      onSuccess: (res: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().successAlert({ title: 'Éxito', message: res.message });
        toast.success(res.message, { autoClose: 2500 });
        onSaved && onSaved();
      },
      onError: (res: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().errorAlert({ title: 'Error', message: res.message });
      },
      onFieldError: (errs: ServiceResponse) => {
        hideLoading?.();
        setErrorFields(errs.data);
      }
    });
  };

  return (
    <>
      {fetchingEditProduct ? null : (
        <>
          <div className="row">
            <div className="col-12">
              <ProductForm
                productDataForm={product}
                setProductDataForm={setProduct}
                units={units}
                ownershipTypes={ownershipTypes}
                taxes={taxes}
                sectors={sectors}
                categories={categories}
                locations={locations}
                qualities={qualities}
                colors={colors}
                errorFields={errorFields}
              />
            </div>
          </div>
          <hr />
          <div className="row justify-content-end">
            <div className="col-auto">
              <ButtonCancelForm callbackCancel={onCancel} locked={!!fetchingStoreProduct} />
            </div>
            <div className="col-auto">
              <ButtonSaveForm callbackSave={store} locked={!!fetchingStoreProduct} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductClone;

